import { AcquiringItem } from 'app/dataTypes/acquiring/settings'

import { calcCommission } from './calcCommission'

type Option = {
  amount: number
  acquiringItem: AcquiringItem
}

export function useAmountTotal({ amount, acquiringItem }: Option) {
  const { commissionPercent, commissionType } = acquiringItem

  if (commissionPercent !== null && commissionType !== null) {
    return commissionType === 'increase'
      ? amount + calcCommission(amount, commissionPercent)
      : amount
  }

  return amount
}
